import React, { useState, useEffect } from 'react';
import BannerText from './BannerText';

const Banner = ({ videoSrc, imageSrc, title, subtitle, description, buttonLabel, buttonDestination, imagePosition }) => {
    // Check if there is no video or image source and no banner text
    const showBannerText = title || subtitle || description || buttonLabel || buttonDestination;

    // State to control the zoom animation
    const [isZooming, setIsZooming] = useState(true);

    // Reset zoom animation when imageSrc changes
    useEffect(() => {
        if (imageSrc) {
            setIsZooming(true);
            const timer = setTimeout(() => {
                setIsZooming(false);
            }, 3000); // Match the CSS animation duration (increased from 1500ms to 3000ms)

            return () => clearTimeout(timer);
        }
    }, [imageSrc]);

    // Determine image positioning class based on prop
    const getImagePositionClass = () => {
        if (imagePosition === 'right') {
            return 'object-right-mobile';
        } else if (imagePosition === 'center') {
            return 'object-center';
        } else if (imagePosition === 'left') {
            return 'object-left-mobile';
        }
        // Default behavior if no position is specified
        return '';
    };

    return (
        <div className="relative min-h-screen flex flex-col justify-center overflow-hidden" id="hero">
            {/* Background Media (Video or Image) */}
            {videoSrc ? (
                <video
                    src={videoSrc}
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="w-full h-full object-cover absolute inset-0 -z-10"
                />
            ) : imageSrc ? (
                <div className="w-full h-full absolute inset-0 -z-10 overflow-hidden">
                    <img
                        src={imageSrc}
                        alt={title || "Banner Image"}
                        className={`w-full h-full object-cover ${getImagePositionClass()} ${isZooming ? 'zoom-out-animation' : ''}`}
                    />
                </div>
            ) : null}

            {/* Render BannerText only if there is any text content */}
            {showBannerText && (
                <BannerText
                    title={title}
                    subtitle={subtitle}
                    description={description}
                    buttonLabel={buttonLabel}
                    buttonDestination={buttonDestination}
                />
            )}
        </div>
    );
};

export default Banner;